import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

class SkillOptionCard extends BaseComponent {
  static properties = {
    name: { type: String },
    slug: { type: String },
    ability: { type: String },
    selected: { type: Boolean },
    disabled: { type: Boolean },
    recommended: { type: Boolean },
    known: { type: Boolean },
  };

  static styles = css`
    :host {
      display: block;
    }
    .card {
      cursor: pointer;
      transition:
        border-color 0.15s,
        box-shadow 0.15s;
      height: 100%;
    }
    .card:hover:not(.disabled) {
      border-color: #0d6efd;
    }
    .card.selected {
      border-color: #0d6efd;
      box-shadow: 0 0 0 1px #0d6efd;
      background-color: rgba(13, 110, 253, 0.04);
    }
    .card.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `;

  constructor() {
    super();
    this.name = '';
    this.slug = '';
    this.ability = '';
    this.selected = false;
    this.disabled = false;
    this.recommended = false;
    this.known = false;
  }

  _onClick() {
    if (this.disabled) return;
    this.dispatchEvent(
      new CustomEvent('card-selected', {
        detail: { slug: this.slug },
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    return html`
      <div class="card ${this.selected ? 'selected' : ''} ${this.disabled ? 'disabled' : ''}" @click="${this._onClick}">
        <div class="card-body py-2 px-3">
          <div class="d-flex align-items-center">
            <input
              type="checkbox"
              class="form-check-input me-2"
              .checked="${this.selected}"
              ?disabled="${this.disabled}"
              @click="${(/** @type {Event} */ e) => {
                e.stopPropagation();
                this._onClick();
              }}"
            />
            <span class="fw-medium">${this.name}</span>${
              this.known
                ? html`<span class="badge bg-secondary bg-opacity-25 text-dark ms-2">Known</span>`
                : this.recommended
                  ? html`<span class="badge bg-primary bg-opacity-25 text-primary ms-2">Recommended</span>`
                  : ''
            }
            ${this.ability ? html` <span class="ms-auto text-muted small text-uppercase">${this.ability}</span> ` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('skill-option-card', SkillOptionCard);
